'use client';

import Image from 'next/image';

interface IProps {
  linkToAppStore?: string | null;
  linkToPlayStore?: string | null;
}

export const DownloadButtons = ({
  linkToAppStore,
  linkToPlayStore,
}: IProps) => {
  return (
    <>
      <div className="mt-4 flex flex-wrap gap-3">
        <Image
          className="h-[41px] cursor-pointer"
          src={'/static/images/apple-store.svg'}
          width={121}
          height={41}
          onClick={() => {
            window.dataLayer?.push({
              event: 'click_app_download',
              app_version: 'AppStore',
            });
            window.open(linkToAppStore || '', '_blank', 'noopener,noreferrer');
          }}
          alt={'Apple Store'}
        />
        <Image
          className="h-[41px] cursor-pointer"
          src={'/static/images/google-play.svg'}
          width={135}
          height={41}
          onClick={() => {
            window.dataLayer?.push({
              event: 'click_app_download',
              app_version: 'PlayStore',
            });
            window.open(linkToPlayStore || '', '_blank', 'noopener,noreferrer');
          }}
          alt={'Google Play Store'}
        />
      </div>
    </>
  );
};
